import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { api } from '../api/client';
import { AuthLayout } from '../components/auth/AuthLayout';
import { Banner, Button, Spinner } from '../components/ui';

const EmailVerification: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('');

  const token = searchParams.get('token');
  const userId = searchParams.get('userId');

  useEffect(() => {
    const verifyEmail = async () => {
      if (!token || !userId) {
        setStatus('error');
        setMessage('Ungültiger Verifizierungslink. Token oder Benutzer-ID fehlt.');
        return;
      }

      try {
        await api.post(`/user/verify-email`, {
          userId,
          token
        });
        setStatus('success');
      } catch (error: any) {
        console.error('Verification failed:', error);
        setStatus('error');
        setMessage(
          error.response?.data?.error ||
          'Verifizierung fehlgeschlagen. Der Link ist möglicherweise abgelaufen.'
        );
      }
    };

    verifyEmail();
  }, [token, userId]);

  const handleGoToDashboard = () => {
    navigate('/dashboard');
  };

  return (
    <AuthLayout title="E-Mail bestätigen">
      {status === 'loading' && (
        <div className="flex flex-col items-center gap-3 py-4 text-center">
          <Spinner size={28} />
          <p className="text-muted">Bitte warte einen Moment.</p>
        </div>
      )}

      {status === 'success' && (
        <div className="flex flex-col gap-4">
          <Banner tone="success" title="E-Mail erfolgreich bestätigt!">
            Vielen Dank! Deine E-Mail-Adresse wurde bestätigt. Du kannst jetzt alle Funktionen nutzen.
          </Banner>
          <Button fullWidth onClick={handleGoToDashboard}>
            Zu deinen Suchen
          </Button>
        </div>
      )}

      {status === 'error' && (
        <div className="flex flex-col gap-4">
          <Banner tone="danger" title="Bestätigung fehlgeschlagen">
            {message}
          </Banner>
          <Button variant="secondary" fullWidth onClick={handleGoToDashboard}>
            Zurück zu deinen Suchen
          </Button>
        </div>
      )}
    </AuthLayout>
  );
};

export default EmailVerification;
